import styled from "styled-components";

const StyledContainer = styled.div`
  .ant-layout-sider-zero-width-trigger {
    z-index: 2;
  }
`;

export default StyledContainer;
